module.exports = __webpack_public_path__ + "static/assets/747b1bd297fb66e3a86260d180362bd2.png";